import $ from "jquery";

export const toggleDiv = () => {
    $(document).on('click', '.toggle-div', function () {
        const toggleBtn = $(this);
        const toggledDivId = $(this).data('toggled');
        const toggledDiv = $(toggledDivId);
        const transitionDuration = 250;

        toggledDiv.stop().slideToggle(transitionDuration);
        toggleBtn.toggleClass('active');
    });
};
